// notification.js
let notifyFunction = null;

export function setNotifyFunction(fn) {
  notifyFunction = fn;
}

export function notify(message, type = 'success', timeout = 5000) {
  if (notifyFunction) {
    notifyFunction(message, type, timeout);
  } else {
    console.warn('Notification function is not set');
  }
}
